<template>
    <div>
        <v-row v-for="(row,rowindex) in rows" :key="rowindex">
            <v-col v-for="(col,colindex) in row" :key="colindex" :cols="12 / row.length">
                <slot :item="col.item" :layout="col.layout" v-if="col" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {chunk} from 'lodash';
export default {
    name: 'zoezi-card-layout',

    props: {
        items: {
            type: Array
        }
    },

    computed: {
        rows() {
            let i = this.items;
            let mobile = this.$vuetify.breakpoint.mobile;

            if (mobile) {
                return i.map(x => ([{item: x}]))
            }

            if (i.length == 1) {
                return [
                    [{item: i[0], layout: 'wide'}]
                ];
            } else if (i.length == 2) {
                return [
                    [{item: i[0]}, {item: i[1]}]
                ];
            } else if (i.length == 3) {
                return [
                    [{item: i[0], layout: 'wide'}],
                    [{item: i[1]}, {item: i[2]}]
                ];
            } else if (i.length == 4) {
                return [
                    [{item: i[0], layout: 'wide'}],
                    [{item: i[1]}, {item: i[2]}, {item: i[3]}]
                ];
            } else if (i.length == 5) {
                return [
                    [{item: i[0]}, {item: i[1]}],
                    [{item: i[2]}, {item: i[3]}, {item: i[4]}]
                ];
            } else if (i.length == 6) {
                return [
                    [{item: i[0]}, {item: i[1]}],
                    [{item: i[2]}, {item: i[3]}, {item: i[4]}, {item: i[5]}]
                ];
            } else if (i.length == 7) {
                return [
                    [{item: i[0]}, {item: i[1]}, {item: i[2]}],
                    [{item: i[3]}, {item: i[4]}, {item: i[5]}, {item: i[6]}]
                ];
            } else if (i.length == 8) {
                return [
                    [{item: i[0]}, {item: i[1]}],
                    [{item: i[2]}, {item: i[3]}, {item: i[4]}],
                    [{item: i[5]}, {item: i[6]}, {item: i[7]}]
                ];
            } else if (i.length >= 9) {
                let result = [
                    [{item: i[0]}, {item: i[1]}]
                ];
                let chunked = chunk(i.slice(2), 4);
                chunked.forEach(row => {
                    row.forEach((item, index) => {
                        row[index] = {item};
                    });
                });
                chunked[chunked.length-1].length = 4;
                result = result.concat(chunked);
                return result;
            } else {
                return [];
            }
        },
    }
}
</script>
